export default "__VITE_ASSET__19f30fa0__"